export default __webpack_public_path__ + "static/media/alpharadar-dash.17b2bb93.jpg";